module.exports = __webpack_public_path__ + "img/values-img-5.e1345184.svg";